// Components.
import ModalAssinaturaEletronica from '@/components/assinatura-eletronica/Modal'

// Others.
import {mapActions, mapGetters} from 'vuex'
import { repository, error, stringCase } from '@/mixins'

// Utils.
import senha from '@/utils/painel-senha/impressao/senha'

export default {
    components: { ModalAssinaturaEletronica },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            loading: 'getLoading',
            lotacao: 'getLotacao',
        }),
    },
    data: () => ({
        modalAssinaturaEletronicaRefName: 'ModalAssinaturaEletronica',
        modalAssinaturaEletronicaProps: {
            skipSignConfirmationMessage: 'Deseja realmente assinar depois?',
            skipSignText: 'Assinar depois',
        },
        afterSign: async () => {},
        onSign: () => {},
        onSkipSign: () => {},
        impressoes: null,
        model: null,
        utils: {senha},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        askToSignAtendimento(signCallback, notSignCallback) {

            this.askToSign('Atendimento salvo. Deseja assinar?', signCallback, notSignCallback)
        },
        askToSign(message, signCallback, notSignCallback) {

            this.showConfirmation(message, signCallback, notSignCallback)
        },
        async sign(impressoes, atendimentoId, id) {
            await this.list(atendimentoId);

            const repository = this.getConectaSusRepository('impressao.ambulatorio')

            this.setLoading()

            const items = {
                senha: async () => this.utils.senha.print({
                    ...impressoes.find(impressao => impressao === 'senha').data,
                    infraestrutura: this.lotacao.infraestrutura.nome,
                    setor: this.centroCusto.setor.nome,
                    cliente: this.cliente.nome,
                })
            }

            const repositoryItems = {
                declaracaoComparecimento: () => repository.declaracaoComparecimento(atendimentoId, {para_assinatura_eletronica: true}),
                cartaMedica: () => repository.cartaMedica(atendimentoId, {para_assinatura_eletronica: true}),
                atendimento: () => repository.atendimento(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaComum: () => repository.receitaMedicaComum(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaEspecial: () => repository.receitaMedicaEspecial(atendimentoId, {para_assinatura_eletronica: true}),
                laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial: () => {

                    const params = impressoes.find(i => Array.isArray(i) && i[0] === 'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial')
                        ? {
                            ...impressoes.find(i => Array.isArray(i) && i[0] === 'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial')[1],
                            itens: impressoes.find(i => Array.isArray(i) && i[0] === 'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial')[1].itens,
                            para_assinatura_eletronica: true
                        }
                        : { itens: [], para_assinatura_eletronica: true }

                    return repository.laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial(atendimentoId, params)
                },
                fichaRequisicaoServicoAuxiliarDiagnoseTerapia: () => {

                    const params = impressoes.find(i => Array.isArray(i) && i[0] === 'fichaRequisicaoServicoAuxiliarDiagnoseTerapia')
                        ? {
                            ...impressoes.find(i => Array.isArray(i) && i[0] === 'fichaRequisicaoServicoAuxiliarDiagnoseTerapia')[1],
                            itens: impressoes.find(i => Array.isArray(i) && i[0] === 'fichaRequisicaoServicoAuxiliarDiagnoseTerapia')[1].itens,
                            para_assinatura_eletronica: true
                        }
                        : { itens: [], para_assinatura_eletronica: true }

                    return repository.fichaRequisicaoServicoAuxiliarDiagnoseTerapia(atendimentoId, params)
                },
                servicoAnaliseDiagnosticoTerapiaSolicitacaoExame: () => {

                    const params = impressoes.find(i => Array.isArray(i) && i[0] === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame')
                        ? {
                            ...impressoes.find(i => Array.isArray(i) && i[0] === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame')[1],
                            itens: impressoes.find(i => Array.isArray(i) && i[0] === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame')[1].itens,
                            para_assinatura_eletronica: true
                        }
                        : { itens: [], para_assinatura_eletronica: true }

                    return repository.servicoAnaliseDiagnosticoTerapiaSolicitacaoExame(atendimentoId, params)
                },
                requisicaoExameCitopatologicoColoUtero: () => repository.requisicaoExameCitopatologicoColoUtero(atendimentoId, {para_assinatura_eletronica: true}),
                requisicaoExameCitopatologicoMama: () => repository.requisicaoExameCitopatologicoMama(atendimentoId, {para_assinatura_eletronica: true}),
                requisicaoExameHistopatologicoMamografia: () => repository.requisicaoExameHistopatologicoMamografia(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaEspecialAzul: () => repository.receitaMedicaEspecialAzul(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaEspecialAmarela: () => repository.receitaMedicaEspecialAmarela(atendimentoId, {para_assinatura_eletronica: true}),
                atestado: () => repository.atestado(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaNaoPadronizada: () => repository.receitaMedicaNaoPadronizada(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaNaoPadronizadaComum: () => repository.receitaMedicaNaoPadronizadaComum(atendimentoId, {para_assinatura_eletronica: true}),
                receitaMedicaNaoPadronizadaEspecial: () => repository.receitaMedicaNaoPadronizadaEspecial(atendimentoId, {para_assinatura_eletronica: true}),
                orientacao: () => repository.orientacao(atendimentoId, {para_assinatura_eletronica: true}),
                encaminhamento: () => repository.encaminhamento(atendimentoId, {para_assinatura_eletronica: true}),
            }

            impressoes.forEach(impressao => {
                if (impressao in items) {
                    items[impressao]().catch(this.handleError)
                }
            })

            const promessas = []

            impressoes.forEach(impressao => {

                const chave = Array.isArray(impressao) ? impressao[0] : impressao

                if (chave in repositoryItems) {

                    const promessa = repositoryItems[chave]()
                        .then(({ data, headers }) => {
                            const blob = new Blob([data], { type: headers['content-type'] })
                            return { blob, fileName: `${chave}-${id}` }
                        })
                        .catch(this.handleError)
                        .finally()

                    promessas.push(promessa)
                }
            })

            Promise.all(promessas)
                .then(arquivos => {
                    const blobs = arquivos.map(arquivo => arquivo.blob)
                    const fileNames = arquivos.map(arquivo => arquivo.fileName)

                    this.$refs[this.modalAssinaturaEletronicaRefName].open(blobs, fileNames, arquivos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list(atendimentoId) {
            const repository = this.getConectaSusRepository('ambulatorio.impressao')

            this.setLoading()

            const request = {
                origem: 'atendimento',
                atendimentoId: atendimentoId,
            }

            return repository.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.impressoes = Object.assign(response.data.form.impressoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, stringCase]
}